import axios, { AxiosResponse } from "axios";
import Utils from "@teamprevent/common/utils";
import { toast } from "@teamprevent/common/toasts";

class ImportToolApi {
    private readonly apiUrl = "/api/importTool";

    public async importData(type: string, file: File): Promise<void> {
        const toastId = toast.copyableInfo("Import in progress...");

        const data = new FormData();
        data.append("file", file);

        let response: AxiosResponse;
        try {
            response = await axios.post(`${this.apiUrl}/${type}`, data);
        } catch {
            toast.dismiss(toastId);
            toast.error("Couldn't perform import due to connection problems");
        }

        setTimeout(() => {
            toast.dismiss(toastId);
            setTimeout(() => Utils.CheckResponse(response.data), 250);
        }, 750);
    }
}

export default new ImportToolApi() as ImportToolApi;
